interface RenderRowCellProps {
  children?: React.ReactNode
  classVariable: any
}
export function RenderRowCell(props: RenderRowCellProps) {
  const { classVariable, children } = props
  return <span style={classVariable}>{children}</span>
}
